import { Component, Input } from "@angular/core";

import { Command } from "../../interfaces";
import { CommandComponent } from "../command/command.component";

@Component({
    selector: "command-bar",
    templateUrl: "./commandBar.tmpl.html",
    imports: [CommandComponent]
})
export class CommandBarComponent
{
    @Input() readonly commands: ReadonlyArray<Command>;
    @Input() dense?: boolean;
    @Input() useMouseDown: boolean;
}
